<template>
    <header class="header_area header_seven">
        <!--header top start-->
        <div class="">
            <div
                v-if="type_message"
                class="alert alert-dismissible fade show"
                :class="type_message"
                role="alert"
            >
                <span v-html="alert_message" />
            </div>
        </div>
        <!--header top start-->
        <!--header center area start-->
        <!--desktop-->
        <div class="d-none d-md-block header_middle header_middle_seven">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-2">
                        <div class="logo">
                            <a href="/"
                                ><img
                                    class="logoBra"
                                    src="/img/LOGO_BRA.webp"
                                    alt=""
                            /></a>
                        </div>
                    </div>

                    <div class="col-lg-10 d-md-block">
                        <div class="row">
                            <div class="col-7 mt-3">
                                <h5 class="mb-0 fs-6" style="color: #2e67ae">
                                    Bem vindo a
                                    <span class="fw-bold" style="color: #dc3545"
                                        >LIGA BRA!</span
                                    >
                                    Pokémon
                                </h5>
                            </div>
                            <div class="col-3 text-center">
                                <Zipcode />
                            </div>
                            <div class="col-2 text-end">
                                <div class="top_right">
                                    <ul style="color: #2e67ae">
                                        <li>
                                            <a
                                                href="/auth/login"
                                                style="font-size: 0.9rem"
                                            >
                                                <img
                                                    style="
                                                        width: 25px;
                                                        margin-left: -28px;
                                                    "
                                                    src="/img/newsIcons/MINHA_CONTA.webp"
                                                    alt=""
                                                />
                                                Minha Conta
                                                <i
                                                    class="fa-solid fa-caret-down"
                                                ></i>
                                            </a>
                                            <ul
                                                v-if="user?.id"
                                                class="dropdown_links"
                                            >
                                                <li>
                                                    <a href="/my-account"
                                                        >Minha Conta
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="/my-store/list"
                                                        >Minha Loja
                                                    </a>
                                                </li>

                                                <li>
                                                    <a
                                                        href="/cart"
                                                        :class="{
                                                            disabled:
                                                                cart.total_price ===
                                                                '0.00',
                                                        }"
                                                        >Carrinho</a
                                                    >
                                                </li>
                                                <li>
                                                    <a
                                                        @click="logout()"
                                                        href="/"
                                                        >Sair</a
                                                    >
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="search_custom col-7">
                                <AutoComplete
                                    v-model="selectedItem"
                                    optionLabel="name"
                                    :suggestions="filtredproducts"
                                    @complete="search"
                                    placeholder="Procure por Cards, Lojas e Produtos..."
                                    class="auto-custom"
                                >
                                    <template #option="slotProps">
                                        <div class="flex align-options-center">
                                            <a
                                                :href="
                                                    '/product/' +
                                                    slotProps.option?.code
                                                "
                                            >
                                                <div
                                                    class="col-1 float-start"
                                                    style="
                                                        min-width: 48px;
                                                        text-align: center;
                                                    "
                                                >
                                                    <!--:alt="slotProps.option?.name"-->
                                                    <img
                                                        :src="
                                                            slotProps.option?.url
                                                        "
                                                        :class="`flag`"
                                                        style="
                                                            max-width: 48px;
                                                            max-height: 48px;
                                                        "
                                                    />
                                                </div>
                                                <div class="col-8 float-start">
                                                    <div class="ms-2">
                                                        {{ slotProps.option?.name }} 
                                                        ({{ slotProps.option?.number || "-" }})
                                                    </div>
                                                    <div class="ms-2">
                                                        {{ slotProps.option?.collection }}
                                                    </div>
                                                    <div class="ms-2">
                                                        Lançamento: {{ slotProps.option?.date }}
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </template>
                                </AutoComplete>
                                <!--<img src="/img/newsIcons/FILTRO_BUSCA.webp"
                  @click="filterProduct()" data-bs-toggle="modal" data-bs-target="#Modal"
                  style="top: 50%; right: 0; transform: translateY(-50%); width: 50px; z-index: 10; margin-left: -50px; margin-top: 20px;"
                  />-->
                                <button
                                    style="
                                        position: relative;
                                        background-color: transparent;
                                        color: #2e67ae;
                                    "
                                    @click="go_search_product()"
                                >
                                    <img
                                        src="/img/newsIcons/LUPA_BUSCA.webp"
                                        alt=""
                                        style="width: 20px"
                                    />

                                    <img
                                        class="ms-2"
                                        src="/img/newsIcons/FILTRO_BUSCA.webp"
                                        @click="filterProduct()"
                                        data-bs-toggle="modal"
                                        data-bs-target="#Modal"
                                        style="
                                            width: 50px;
                                            background-color: transparent;
                                            position: relative;
                                        "
                                    />
                                </button>

                                <!--<button
                  style="position: relative; bottom: 1px; background-color: transparent; color: #2e67ae;"
                  @click="go_search_product()"
                >
                </button>-->
                            </div>
                            <div class="col-3 ps-4" style="color: #2e67ae">
                                <p v-if="!user?.id">
                                    <span
                                        ><strong class="d-block"
                                            >Bem-vindo</strong
                                        ></span
                                    >
                                    <a href="/auth/login" class="no-spacing"
                                        >Entre ou cadastre-se</a
                                    >
                                </p>
                                <p v-else>
                                    <span>
                                        <strong class="d-block ms-2 mb-0"
                                            >Bem vindo</strong
                                        >
                                        <h5
                                            class="d-block ms-2 fs-6"
                                            style="margin-top: -5px"
                                        >
                                            {{ user.name }} {{ user.last_name }}
                                        </h5>
                                    </span>
                                </p>
                            </div>
                            <div class="col-2 px-0">
                                <div class="float-end">
                                    <Notice />
                                </div>
                                <div class="float-end">
                                    <mini-card />
                                </div>
                            </div>

                            <!--<FreeShippingNotice />-->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--mobile-->
        <div class="d-block d-md-none header_middle header_middle_seven">
            <div class="container-full">
                <div
                    class="d-block d-md-none text-white px-3 py-1 mb-3"
                    style="font-size: 14px; background-color: #333333"
                >
                    <div class="d-flex align-items-center">
                        <div class="d-flex align-items-center">
                            <div class="float-end mb-1 mr-4">
                                <Zipcode smallIcon />
                            </div>
                        </div>

                        <div
                            class="d-flex align-items-center ms-auto ml-auto gap-2 justify-content-end"
                        >
                            <img
                                src="/img/BANDEIRAS/BRASIL.webp"
                                alt="BR"
                                style="width: 36px; height: auto"
                            />
                            <img
                                src="/img/BANDEIRAS/EUA.webp"
                                alt="EN"
                                style="width: 36px; height: auto"
                            />
                            <img
                                src="/img/BANDEIRAS/JAPAO.webp"
                                alt="JP"
                                style="width: 36px; height: auto"
                            />
                        </div>
                    </div>
                </div>

                <div class="row align-items-center px-4">
                    <!-- Ícone do menu -->
                    <div class="col-4">
                        <router-link
                            :to="toggleMenuRoute"
                            @click.native="handleToggleClick"
                        >
                            <i class="fas fa-bars fs-1 ms-2 text-blue"></i>
                        </router-link>
                    </div>

                    <!-- Logo centralizada -->
                    <div class="col-4">
                        <a href="/"
                            ><img
                                class="logoBra"
                                src="/img/LOGO_BRA.webp"
                                alt="Logo BRA"
                        /></a>
                    </div>

                    <div class="col-4">
                        <div
                            class="d-flex justify-content-end align-items-center gap-3 "
                        >
                            <template v-if="user?.id">
                                <div class="notice-mobile-wrapper">
                                    <Notice class="notice-mobile" />
                                </div>
                            </template>
                            <template v-else>
                                <a href="/auth/login">
                                    <img
                                        class="w-auto minhaConta"
                                        src="/img/newsIcons/MINHA_CONTA.webp"
                                        alt="Minha Conta"
                                    />
                                </a>
                            </template>
                            <mini-card />
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center mt-1">
                    <div class="col-12 text-center">
                        <h5 class="mb-0" style="color: #2e67ae">
                            Bem-vindo a
                            <span class="fw-bold" style="color: #dc3545"
                                >LIGA BRA!</span
                            >
                            Pokémon
                        </h5>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col-12">
                        <div class="p-3 bg-blue">
                            <AutoComplete
                                v-model="selectedItem"
                                optionLabel="name"
                                :suggestions="filtredproducts"
                                @complete="search"
                                placeholder="Procure por Cards, Lojas e Produtos..."
                                :class="[
                                    'auto-custom',
                                    {
                                        'custom-hide-menu':
                                            $route.path === '/hide-menu',
                                    },
                                ]"
                            >
                                <template #option="slotProps">
                                    <div class="flex align-options-center">
                                        <a
                                            :href="
                                                '/product/' +
                                                slotProps.option?.code
                                            "
                                        >
                                            <div
                                                class="col-1 float-start"
                                                style="
                                                    min-width: 48px;
                                                    text-align: center;
                                                "
                                            >
                                                <!--:alt="slotProps.option?.name"-->
                                                <img
                                                    :src="slotProps.option?.url"
                                                    :class="`flag`"
                                                    style="
                                                        max-width: 48px;
                                                        max-height: 48px;
                                                    "
                                                />
                                            </div>
                                            <div class="col-8 float-start">
                                                <div class="ms-2">
                                                    {{ slotProps.option?.name }}
                                                    ({{ slotProps.option?.number }}) - {{ slotProps.option?.codePro }}
                                                </div>
                                                <div class="ms-2">
                                                    {{ slotProps.option?.codeCat }}
                                                    -
                                                    {{ slotProps.option?.series }}
                                                </div>
                                                <div class="ms-2">
                                                    Lançamento: {{ slotProps.option?.date }}
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </template>
                            </AutoComplete>
                            <div
                                :class="[
                                    'search_custom',
                                    {
                                        'search-hide-custom':
                                            $route.path === '/hide-menu',
                                    },
                                ]"
                                class=""
                            >
                                <button @click="go_search_product()">
                                    <img
                                        src="/img/newsIcons/LUPA_BUSCA.webp"
                                        alt=""
                                        style="width: 20px"
                                    />

                                    <img
                                        class="ms-2"
                                        src="/img/newsIcons/FILTRO_BUSCA.webp"
                                        @click="filterProduct()"
                                        data-bs-toggle="modal"
                                        data-bs-target="#Modal"
                                        style="width: 47px"
                                    />
                                </button>

                                <FilterProductModal :visible="showFilterProduct" @close="showFilterProduct = false"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-none d-md-block">
            <Modal :component_name="is_modal" :data="data" />
            <!--header center area end-->

            <!--header middel start-->
            <navbar />
        </div>
    </header>

</template>

<script>
import MiniCard from "./MiniCard.vue";
import Navbar from "./Navbar.vue";
import SideMenuMobile from "./SideMenuMobile.vue";
import AutoComplete from "primevue/autocomplete";
import Modal from "./Modal.vue";
import Zipcode from "./Zipcode.vue";
import Notice from "./realtime/Notice.vue";
import FreeShippingNotice from "./FreeShippingNotice.vue";
import FilterProductModal from "./product/FilterProductModal.vue";

export default {
    components: {
        SideMenuMobile,
        MiniCard,
        Navbar,
        AutoComplete,
        Modal,
        Zipcode,
        Notice,

        FreeShippingNotice,
        FilterProductModal
    },
    data() {
        return {
            search_product: "",
            category_id: "",
            selectedItem: "",
            data: "",
            full: false,
            showComponentMobile: false,
            showFilterProduct: false,
            previousRoute: null,
        };
    },
    mounted() {
        this.checkIfMobile();
        window.addEventListener("resize", this.checkIfMobile); // Detecta mudanças de tamanho de tela
    },
    destroyed() {
        window.removeEventListener("resize", this.checkIfMobile); // Remove o listener quando o componente for destruído
    },
    methods: {
        search(event) {
            this.$store.dispatch("product/get_products", {
                per_page: 20,
                current_page: 1,
                category_id: this.category_id, //category id
                name: event.query,
                type: "filter",
                full: this.full,
            });
        },

        logout() {
            this.$store.dispatch("token/unable_token").then(() => {
                this.$store.dispatch("user/logout");
            });
        },
        go_search_product() {
            if (!this.selectedItem.length) {
            } else {
                this.$router.push(
                    "/filter-products/" +
                        this.selectedItem +
                        "/" +
                        this.category_id
                );
            }
            // window.location = "/filter-products/"+this.search_product
        },
        select_category(event) {
            this.category_id = event.target.value;
        },
        filterProduct() {
            this.$store.dispatch("alert/set_modal", "FilterProduct");
            if (window.innerWidth <= 768) {
                this.showFilterProduct = true;
            }
        },
        checkIfMobile() {
            this.showComponentMobile = window.innerWidth <= 768; // Define como mobile se a largura for menor ou igual a 768px
        },
        handleToggleClick() {
            if (this.$route.path !== "/hide-menu") {
                // se estou fora do hide-menu, salvo onde estou
                this.previousRoute = this.$route.fullPath;
            }
        },
    },
    computed: {
        user() {
            return this.$store.state.user.current_user;
        },
        guest() {
            return this.$store.state.user.guest;
        },
        categories() {
            return this.$store.state.category.categories;
        },
        filtredproducts() {
            return this.$store.state.product.filter_products;
        },
        alert_message() {
            return this.$store.state.alert.alert_message;
        },
        type_message() {
            return this.$store.state.alert.type_message;
        },
        is_modal() {
            return this.$store.state.alert.modal;
        },
        cart() {
            return this.$store.state.cart.cart;
        },
        toggleMenuRoute() {
            if (this.$route.path === "/hide-menu" && this.previousRoute) {
                return this.previousRoute; // se já estou no hide-menu, volto
            }
            return "/hide-menu"; // se estou fora, vou para o hide-menu
        },
        /*cookies() {
      return this.$store.state.user.cookies;
    }*/
    },
    beforeCreate() {
        this.$store.dispatch("user/login_keycloak");
        this.$store.dispatch("user/get_current_user");
        // this.$store.dispatch("user/set_guest_user");
        this.$store.dispatch("user/get_favorites");
        // this.$store.dispatch("category/get_categories");
        this.$store.dispatch("attributes/get_conditions", (this.is_bra ? 'bra' : 'card'));
        this.$store.dispatch("attributes/get_rarities");
        this.$store.dispatch("attributes/get_origins");

        this.$store.dispatch("category/get_collection_navbar", {
            per_page: 14,
            current_page: 1,
            id: 1,
        });

        this.$store.dispatch("category/get_tcg_navbar", {
            per_page: 9,
            current_page: 1,
            id: 2,
        });
        //this.$store.dispatch("user/get_cookies");
    },
};
</script>
<style scoped>
.no-spacing {
    margin-top: -10px !important;
    padding: 0;
    display: block;
    /* ou inline-block, dependendo do seu layout */
}

.alert {
    position: fixed;
    right: 1%;
    top: 1%;
    z-index: 2;
}
.search_custom {
    position: relative;
    bottom: 5px;
}
.search_custom button {
    border: 0;
    position: absolute;
    top: -2px;
    bottom: -2px;
    right: 40px;
    font-size: 16px;
    font-weight: 500;
    border-radius: 35px 0 0 35px;
    -webkit-transition: 0.3s;
    transition: 0.3s;
}

#advanceFilter {
    position: relative;
    width: 50px;
    margin-left: -40px;
}

.logoBra {
    width: 170px;
}

.auto-custom {
    border: 2px solid #007bff;
    width: 78%;
    /* Azul padrão */
    border-radius: 8px;
    /* Bordas arredondadas */
}

.auto-custom >>> .p-autocomplete-input {
    width: 100% !important;
    /*margin-left: -12px !important;*/
}

.disabled {
    pointer-events: none;
    opacity: 0.5;
}

@media (min-width: 360px) and (max-width: 768px) {
    .logoBra {
        width: 100px !important;
        margin-left: 10px;
    }
    .auto-custom {
        border: 2px solid #007bff;
        width: 100% !important;
        border-radius: 8px;
    }
    .auto-custom >>> input::placeholder {
        font-size: 14px;
    }
    .search_custom button {
        border: 0;
        position: absolute;
        top: -36.5px;
        bottom: -2px;
        right: -4px;
        font-size: 16px;
        font-weight: 500;
        border-radius: 35px 0 0 35px;
        -webkit-transition: 0.3s;
        transition: 0.3s;
        background-color: transparent !important;
    }
    .search-hide-custom button {
        right: 15px;
    }
    .minhaConta {
        height: 20px;
        margin-top: 5px;
    }
    .custom-hide-menu {
        border: 2px solid #007bff;
        width: 90% !important;
        border-radius: 8px;
        margin-left: 15px;
    }
    .custom-hide-menu >>> input::placeholder {
        font-size: 12px;
    }
    .notice-mobile-wrapper {
        position: relative;
    }
    .notice-mobile {
        position: relative !important;
        top: 3px !important;
    }
}
</style>
